import update from 'immutability-helper';

const personConsentReducer = (state = {failure: false, submitting: false, formSubmitSuccess: false, formSubmitFailure: false, fetchers: 0, club: {Address: {}}, personConsent: {}}, action) => {
  switch (action.type) {
    case 'FETCHING_CLUB':
      return update(state, {'fetchers': {$apply: (x) => {return x + 1;}}});
    case 'FETCH_CLUB_SUCCESS':
      return update(state, {'club' : {$set: action.data}, 'fetchers': {$apply: (x) => {return x - 1;}}});
    case 'FETCH_CLUB_FAILED':
      return update(state, {'failure': {$set: true}});


    case 'FETCHING_PERSONCONSENT':
      return update(state, {'fetchers': {$apply: (x) => {return x + 1;}}});
    case 'FETCH_PERSONCONSENT_SUCCESS':
      return update(state, {'personConsent' : {$set: action.data}, 'fetchers': {$apply: (x) => {return x - 1;}}});
    case 'FETCH_PERSONCONSENT_FAILED':
      return update(state, {'failure': {$set: true}});


    case 'SUBMITING_FORM':
      return update(state, {'submitting': {$set: true}});
    case 'SUBMIT_FORM_SUCCESS':
      return  update(state, {'submitting': {$set: false}, 'formSubmitSuccess': {$set: true}});
    case 'SUBMIT_FORM_FAILED':
    return  update(state, {'submitting': {$set: false}, 'formSubmitFailure': {$set: true}});

    default:
      return state;
  }
}
export default personConsentReducer



// WEBPACK FOOTER //
// ./src/personconsent/reducer.jsx